// src/data/jobs/jobsData.de.ts

export const jobsDataDE = [
  {
    question: "Verkaufsmanager",
    answer: `<div class="brxe-eizqnm brxe-text-basic bc-expander-answer"><p>Wir sind ein dynamisch wachsendes und ambitioniertes Unternehmen, das seine Kundenbasis kontinuierlich erweitert. Im Zuge unseres Geschäftswachstums suchen wir einen Verkaufsmanager, der mit unseren bestehenden Kunden arbeitet und uns hilft, neue Höhen zu erreichen!</p>
<p><strong>Was wir bieten:</strong></p>
<ul>
<li>Wettbewerbsfähiges Gehalt: 3000 € (zuzüglich Boni für erreichte Ziele).</li>
<li>Karrieremöglichkeiten: Ihr Erfolg im Verkauf eröffnet Ihnen neue Entwicklungsmöglichkeiten innerhalb des Unternehmens.</li>
<li>Arbeiten im Team von Profis: eine ambitionierte Atmosphäre und ein kollektiv ausgerichtet auf gemeinsame Erfolge.</li>
<li>Komfortables Büro mit modernen Annehmlichkeiten für eine produktive Arbeitsumgebung.</li>
<li>Zusätzliche Boni und Anreize: Wir schätzen Ihre Anstrengungen und sind immer bereit, gute Leistungen zu belohnen!</li>
</ul>
<p><strong>Ihre Aufgaben:</strong></p>
<ul>
<li>Pflege von Bestandskunden: Aufbau langfristiger Beziehungen und Steigerung des Verkaufsvolumens.</li>
<li>Führung von Verhandlungen und Abschluss neuer Verträge.</li>
<li>Präsentation von Produkten und Dienstleistungen: Darstellung des Mehrwerts unserer Lösungen für die Kunden.</li>
</ul>
<p><strong>Was wir von Ihnen erwarten:</strong></p>
<ul>
<li>Erfahrung im Verkauf.</li>
<li>Fähigkeit, vertrauensvolle Beziehungen zu Kunden aufzubauen und erfolgreich zu verhandeln.</li>
<li>Ergebnisorientierung und die Fähigkeit, gesetzte Ziele zu erreichen.</li>
<li>Hervorragende Kommunikationsfähigkeiten und Hartnäckigkeit.</li>
<li>Fließende Deutschkenntnisse in Wort und Schrift – Voraussetzung für die Arbeit mit Kunden und Partnern.</li>
<li>Wunsch nach persönlicher und beruflicher Weiterentwicklung im Verkaufsbereich.</li>
</ul>
</div>`,
    description: "Büro im Bezirk Pankow, Berlin.",
  },
  {
    question: "Kfz-Mechaniker",
    answer: `<div class="brxe-eizqnm brxe-text-basic bc-expander-answer"><p>Unternehmen: HIXA GmbH lädt erfahrene Kfz-Mechaniker ein, Teil unseres modernen und dynamisch wachsenden Autowerkstatt-Teams zu werden!</p>
<p><strong>Warum sollten Sie bei uns arbeiten?</strong></p>
<ul>
<li>Wettbewerbsfähiges Gehalt + Boni für hervorragende Ergebnisse!</li>
<li>Offizielle Anstellung und ein vollständiges Sozialpaket – wir kümmern uns um unser Personal.</li>
<li>Freundliches Team und komfortable Arbeitsbedingungen – Arbeiten in einer Atmosphäre der gegenseitigen Unterstützung und Professionalität.</li>
</ul>
<p><strong>Was wir suchen:</strong></p>
<ul>
<li>Erfahrene Kfz-Mechaniker mit Erfahrung in der Reparatur von PKWs.</li>
<li>Kenntnisse der grundlegenden Autosysteme und die Fähigkeit, mit modernem Diagnoseequipment zu arbeiten.</li>
<li>Teamfähigkeit und der Wunsch, sich in Ihrem Beruf weiterzuentwickeln.</li>
</ul>
<p><strong>Ihre Aufgaben:</strong></p>
<ul>
<li>Reparatur von Getrieben (einschließlich DSG) bei PKWs.</li>
<li>Fehlerdiagnose mit modernster Ausrüstung.</li>
<li>Wartung und Instandsetzung von Fahrzeugen sowie Teilewechsel.</li>
</ul>
<p><strong>Was wir bieten:</strong></p>
<ul>
<li>Wir schätzen Professionalität und bieten echte Karriere- und Entwicklungsmöglichkeiten.</li>
<li>Wir erwarten qualitativ hochwertige Arbeit und sind bereit, Ihre Anstrengungen angemessen zu belohnen.</li>
<li>Wir unterstützen diejenigen, die wachsen und sich weiterentwickeln möchten, und bieten hervorragende Bedingungen für Profis.</li>
</ul>
</div>`,
    description: "Werkstatt im Bezirk Pankow, Berlin",
  },
  {
    question:
      "Mechaniker für Mechatronik-Reparatur (DSG, S-tronic, PowerShift)",
    answer: `<div class="brxe-eizqnm brxe-text-basic bc-expander-answer"><p>Die HIXA GmbH ist ein modernes Autoservice-Center, spezialisiert auf Ausbau/Einbau, Instandsetzung und Programmierung von Mechatronik-Einheiten. Wir sind stolz auf die hohe Qualität unserer Dienstleistungen und die Professionalität unseres Teams. Wir arbeiten nach Herstellervorgaben, streben nach Bestleistung und fokussieren uns auf messbare Ergebnisse.</p>
<p><strong>Wir suchen:</strong></p>
<ul>
<li>Einen erfahrenen Mechaniker für die Reparatur von Mechatronik-Einheiten (DSG, S-tronic, PowerShift) – Diagnose, Ausbau/Einbau am Fahrzeug, Instandsetzung von Hydraulikblöcken und Programmierung/Codierung der Getriebesteuergeräte.</li>
</ul>
<p><strong>Ihre Aufgaben:</strong></p>
<ul>
<li>Diagnose von Mechatronik-Fehlern (Hydraulik/Elektronik) und systematische Fehlersuche.</li>
<li>Ausbau und Einbau der Mechatronik am Fahrzeug inkl. notwendigem Ölwechsel nach Vorgabe.</li>
<li>Instandsetzung, Dichtigkeits- und Funktionsprüfung von Hydraulikeinheiten.</li>
<li>Programmierung und Codierung der Getriebesteuergeräte (ODIS/VCDS).</li>
<li>Qualitätsprüfung, Dokumentation und Übergabe an den Kunden.</li>
</ul>
<p><strong>Wir bieten:</strong></p>
<ul>
<li>Wettbewerbsfähiges Gehalt (Fixum + Prämien).</li>
<li>Moderne Diagnoseplätze, Spezial-Werkzeuge und Prüfstände für Mechatronik.</li>
<li>Weiterbildung und Entwicklung in einem stabilen Unternehmen.</li>
<li>Angenehme Arbeitsbedingungen und ein kollegiales, hilfsbereites Team.</li>
</ul>
<p><strong>Anforderungen:</strong></p>
<ul>
<li>Praxis in der Mechatronik-Reparatur von DSG, S-tronic oder PowerShift.</li>
<li>Fundierte Kenntnisse in Hydraulik und Grundlagen der Fahrzeugelektronik.</li>
<li>Sicherer Umgang mit Diagnosesystemen (ODIS, VCDS).</li>
<li>Sorgfalt, Verantwortungsbewusstsein und hoher Qualitätsanspruch an die eigene Arbeit.</li>
</ul>
</div>`,
    description: "Werkstatt im Bezirk Pankow, Berlin",
  },
];
